import React, { useState } from 'react';
import { Box, Button, Input, FormControl, FormLabel, Modal, ModalOverlay, ModalContent, ModalHeader, ModalBody, ModalFooter, useDisclosure, Text } from '@chakra-ui/react';
import { createClient } from '@supabase/supabase-js';

// Supabase config
const SUPABASE_URL = 'https://xlgbokglmvtwrgyjoegq.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InhsZ2Jva2dsbXZ0d3JneWpvZWdxIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDgzMjAwMTksImV4cCI6MjA2Mzg5NjAxOX0.f3pvp_DO_0qHRIHjixoqPVLq1uKn0NslnauiaSIvLy0';
const supabase = createClient(SUPABASE_URL, SUPABASE_KEY);

export default function PostPortfolio() {
  const { isOpen, onOpen, onClose } = useDisclosure({ defaultIsOpen: true });
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', category: '', url: '', image: null });
  const [uploading, setUploading] = useState(false);
  const [success, setSuccess] = useState('');
  const [error, setError] = useState('');

  const handleLogin = () => {
    if (username === 'admin' && password === '1234') {
      setIsLoggedIn(true);
      onClose();
    } else {
      setError('Invalid credentials');
    }
  };

  const handleChange = e => {
    const { name, value, files } = e.target;
    setForm(f => ({ ...f, [name]: files ? files[0] : value }));
  };

  const handleSubmit = async e => {
    e.preventDefault();
    setUploading(true);
    setError('');
    setSuccess('');
    try {
      let imageUrl = '';
      if (form.image) {
        const fileExt = form.image.name.split('.').pop();
        const fileName = `${Date.now()}.${fileExt}`;
        const { data, error: uploadError } = await supabase.storage.from('portfolio').upload(fileName, form.image);
        if (uploadError) throw uploadError;
        const { data: publicUrlData } = supabase.storage.from('portfolio').getPublicUrl(fileName);
        imageUrl = publicUrlData.publicUrl;
      }
      // Insert into Supabase table (assume table name 'portfolio')
      const { error: insertError } = await supabase.from('portfolio').insert([
        {
          title: form.title,
          description: form.description,
          category: form.category,
          url: form.url,
          imageUrl,
          createdAt: new Date().toISOString(),
        },
      ]);
      if (insertError) throw insertError;
      setSuccess('Portfolio item added!');
      setForm({ title: '', description: '', category: '', url: '', image: null });
    } catch (err) {
      setError('Error uploading: ' + err.message);
    }
    setUploading(false);
  };

  return (
    <Box maxW="500px" mx="auto" mt={20}>
      <Modal isOpen={isOpen && !isLoggedIn} onClose={onClose} isCentered>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Admin Login</ModalHeader>
          <ModalBody>
            <FormControl mb={3}>
              <FormLabel>Username</FormLabel>
              <Input value={username} onChange={e => setUsername(e.target.value)} />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel>Password</FormLabel>
              <Input type="password" value={password} onChange={e => setPassword(e.target.value)} />
            </FormControl>
            {error && <Text color="red.500">{error}</Text>}
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="blue" mr={3} onClick={handleLogin}>Login</Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
      {isLoggedIn && (
        <Box p={6} bg="white" rounded="lg" shadow="md">
          <form onSubmit={handleSubmit}>
            <FormControl mb={3} isRequired>
              <FormLabel>Title</FormLabel>
              <Input name="title" value={form.title} onChange={handleChange} />
            </FormControl>
            <FormControl mb={3} isRequired>
              <FormLabel>Description</FormLabel>
              <Input name="description" value={form.description} onChange={handleChange} />
            </FormControl>
            <FormControl mb={3} isRequired>
              <FormLabel>Category</FormLabel>
              <Input name="category" value={form.category} onChange={handleChange} />
            </FormControl>
            <FormControl mb={3}>
              <FormLabel>URL</FormLabel>
              <Input name="url" value={form.url} onChange={handleChange} />
            </FormControl>
            <FormControl mb={3} isRequired>
              <FormLabel>Image</FormLabel>
              <Input type="file" name="image" accept="image/*" onChange={handleChange} />
            </FormControl>
            <Button type="submit" colorScheme="teal" isLoading={uploading} w="full" mt={4}>Submit</Button>
            {success && <Text color="green.500" mt={2}>{success}</Text>}
            {error && <Text color="red.500" mt={2}>{error}</Text>}
          </form>
        </Box>
      )}
    </Box>
  );
}
